module.exports = __webpack_public_path__ + "4b27e380e3d9d24fb8845309241c6548.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/GT-Walsheim-Pro-Medium.ttf
// module id = 1242
// module chunks = 0